import request from 'assets/js/http';

export function sectorList() {
  // 获取sector列表
  return request({
    url: '/sector/list',
    method: 'post'
  });
}
export function sectorDelete(data) {
  // 删除sector
  return request({
    url: '/sector/delete',
    method: 'post',
    data
  });
}
export function sectorAction(data) {
  // 新增-修改 sector
  let url = '/sector/add';
  if (data.id || data.id === 0) {
    url = '/sector/edit';
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
export function hideOrReset(data) {
  // 隐藏或恢复sector
  return request({
    url: '/sector/hideOrReset',
    method: 'post',
    data
  });
}
export function getSubSectorList(data) {
  // 查询子sector列表
  return request({
    url: '/company/querySubSectorSet',
    method: 'post'
  });
}
